import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children, roles }) {
    const { user, loading } = useAuth();
    const location = useLocation();
    if (loading) {
        return (
            <div className="min-h-[60vh] flex items-center justify-center text-muted-foreground">
                Loading…
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;

    // Force first-login password change before any other route is accessible.
    // This guard runs BEFORE the role check so a forced-pwd student hitting /admin
    // still lands on the change-password screen (not the public catalog).
    if (
        user.must_change_password &&
        location.pathname !== "/account/change-password"
    ) {
        return <Navigate to="/account/change-password" replace />;
    }

    if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
    return children;
}
